import { getDefaultHomeRole, useHomeRole } from "components/materials/home/use-home-role";
import { useCapabilities } from "store/capability-hooks";
import { useAppSelector } from "store/index";
import { sectionUserSelectors, selectLastHomeRole } from "store/selectors";
import { homeUrlForRole } from "utils/urls";

export const useHomeUrl = () => {
  const { canAuthorOrg } = useCapabilities();
  const lastHomeRole = useAppSelector(selectLastHomeRole);
  const sectionUsers = useAppSelector(sectionUserSelectors.filterForCurrentUser);
  const isStaffInAnySection = sectionUsers.some((cu) => cu.role !== "student");
  const defaultHomeRole = getDefaultHomeRole(canAuthorOrg, isStaffInAnySection);
  const { availableRoles } = useHomeRole();

  if (lastHomeRole && availableRoles.includes(lastHomeRole)) {
    return homeUrlForRole(lastHomeRole);
  }

  if (availableRoles.includes(defaultHomeRole)) {
    return homeUrlForRole(defaultHomeRole);
  }

  return homeUrlForRole("student");
};
